import { render, staticRenderFns } from "./user-profile-modal.vue?vue&type=template&id=480383c6"
import script from "./user-profile-modal.vue?vue&type=script&lang=js"
export * from "./user-profile-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports